import React, { useEffect, useState } from 'react';
import { Box, Fab, IconButton, Tooltip, Typography } from '@mui/material';
import ChatIconImg from '../assets/socialLinks.png';
import MessengerIcon from '../assets/social/messenger.png';
import FacebookIcon from '../assets/social/fb.png';
import InstagramIcon from '../assets/social/instagram.png';
import LineIcon from '../assets/social/line.png';
import TelegramIcon from '../assets/social/telegram.png';
import TwitterIcon from '../assets/social/twitter.png';
import ViberIcon from '../assets/social/viber.png';
import WeChatIcon from '../assets/social/wechat.png';
import WhatsAppIcon from '../assets/social/wa.png';
import YouTubeIcon from '../assets/social/yt.png';
import PinterestIcon from '../assets/social/pinterest.png';
import { getSocialLinks } from '../utils/socialLinks';
import { useDispatch, useSelector } from '../redux/store';

const FloatingIcons = () => {
  const { siteSettings } = useSelector((x) => x.lookup);
  const [chatLinks, setChatLinks] = useState([]);

  const FloatingChatItem = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    gap: 1,
    px: 1,
    py: 1.2,
    cursor: 'pointer',
    borderRadius: '12px 0 0 12px',
    border: '1px solid #f5b007',
    background: 'linear-gradient(180deg, #FFC933 0%, #F5B400 100%)',
    boxShadow: '0px 2px 6px 0px #000000B2',
    transition: 'all 0.25s ease',
  };

  useEffect(() => {
    const links = getSocialLinks(siteSettings).filter((item) => item.url !== '' && item.url !== undefined);
    setChatLinks(links);
  }, [siteSettings]);

  if (!chatLinks.length) return null;

  return (
    <>
      <Box
        sx={{
          position: 'fixed',
          bottom: {
            xs: 360,
            sm: 200,
            md: 430,
          },
          right: 0,
          display: 'flex',
          flexDirection: 'column',
          zIndex: 1300,
        }}
      >
        <Box sx={FloatingChatItem}>
          {chatLinks.map((item) => (
            <Tooltip key={item.id} title={item.name} placement="left">
              <Box onClick={() => window.open(item.url, '_blank')}>
                <img src={item.icon} alt={item.name} width={22} height={22} style={{ objectFit: 'contain' }} />
              </Box>
            </Tooltip>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default FloatingIcons;
